import { AnyAction } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import { Dropdown } from 'primereact/dropdown'
import React, { Dispatch, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { fetchGameLocalesRequest } from '../../../redux/actions/gameActions'
import { CHANGE_SELECTED_LANGUAGE } from '../../../redux/actionTypes/gameActionTypes'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import { GameState } from '../../../redux/types/game'
import jwt_decode from 'jwt-decode'

const Language = ({
  style = null,
  withCode = false,
  onChange = null,
}: {
  style?: any
  fullWidth?: boolean
  withCode?: boolean
  onChange?: any
}) => {
  //   const [selectedLanguage, setSelectedLanguage] = useState<any>(null)
  const {
    data: { gameLocales, selectedLanguage },
    loading: gameLoading,
  }: GameState = useSelector(getGameSelector)
  const dispatch: Dispatch<AnyAction> = useDispatch()
  const { i18n } = useTranslation()
  const token = localStorage.getItem('tokenCityHunt') ?? ''
  const { GameId, GameCode }: any = jwt_decode(token)

  Sentry.setContext('Variables', {
    GameId,
    GameCode,
  })

  useEffect(() => {
    if (!gameLocales) {
      dispatch(fetchGameLocalesRequest(GameId))
    }
  }, [gameLocales])

  const onLanguageChange = (e: { value: any }) => {
    dispatch({ type: CHANGE_SELECTED_LANGUAGE, payload: e.value })
    const language = { ...e.value, gameId: GameId, gameCode: GameCode }
    localStorage.setItem(`hunt-lang`, JSON.stringify(language))
    i18n.changeLanguage(e.value.code)
    onChange && onChange(e.value.id)
  }

  if (gameLoading.isLoadingGameLocales) {
    return <LoadingSpinner />
  }

  const countryOptionTemplate = (option: any) => {
    return (
      <div className="flex align-items-center">
        <div className="ml-3">
          {!withCode ? option.name : option.code.toUpperCase()}
        </div>
      </div>
    )
  }

  const selectedCountryTemplate = (
    option: { name: string; code: string },
    props: { placeholder: string },
  ) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <div className="ml-3">
            {!withCode ? option.name : option.code.toUpperCase()}
          </div>
        </div>
      )
    }

    return <span>{props.placeholder}</span>
  }

  return (
    <Dropdown
      value={selectedLanguage}
      options={gameLocales ?? []}
      onChange={onLanguageChange}
      optionLabel="name"
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      placeholder={withCode ? selectedLanguage?.code : selectedLanguage?.name}
      style={style}
      itemTemplate={countryOptionTemplate}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      valueTemplate={selectedCountryTemplate}
    />
  )
}

export default Language
